import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d025b0cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "type_mfa" }


export default /*#__PURE__*/_defineComponent({
  __name: 'typeMfa',
  props: {
  value: { type: Object, required: true },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(`${__props.value.className} cell-status`)
    }, _toDisplayString(__props.value.name), 3),
    (__props.value?.name2)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(`${__props.value.className} cell-status`)
        }, _toDisplayString(__props.value.name2), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})